import { StorageService } from "./StorageUtils";

async function saveLastFiveApicalls(newData) {
  // Get the existing stored data from AsyncStorage
  const storedData = StorageService.getItem("apiData");
  // Parse the stored data or initialize an empty array
  const parsedData = storedData ? JSON.parse(storedData) : [];
  // Update the parsed data array with the new data and keep only the last 3 elements
  const updatedData = [...parsedData.slice(-4), newData];
  // Store the updated data in AsyncStorage
  StorageService.setItem("apiData", JSON.stringify(updatedData));
}

function generateCurlCommand(config) {
  let command = `curl -X ${config.method} "${config.url}"`;
  // Add headers to the CURL command
  for (const header in config.headers) {
    command += ` -H "${header}: ${config.headers[header]}"`;
  }
  // Add data for POST or PUT requests if present
  if (config.data) {
    command += ` -d '${JSON.stringify(config.data)}'`;
  }
  return command;
}

export { saveLastFiveApicalls, generateCurlCommand };
